/**
 * CreateEventModal - Modal to create an event by name. Uses default times; user edits details on event page.
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createEvent } from '../helpers/eventsHelpers';
import ModalShell from './ModalShell';
import toast from 'react-hot-toast';

function defaultEventTimes() {
  const start = new Date();
  start.setDate(start.getDate() + 1);
  start.setHours(18, 0, 0, 0);
  const end = new Date(start);
  end.setHours(20, 0, 0, 0);
  return {
    start_time: start.toISOString(),
    end_time: end.toISOString(),
  };
}

function CreateEventModal({ onClose, onSuccess, navigateOnSuccess = true }) {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || saving) return;
    setSaving(true);
    try {
      const { start_time, end_time } = defaultEventTimes();
      const event = await createEvent({
        name: name.trim(),
        description: null,
        start_time,
        end_time,
      });
      toast.success('Event created');
      onClose?.();
      onSuccess?.(event);
      if (navigateOnSuccess) {
        navigate(`/events/${event.event_id}`);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalShell title="New Event" onClose={onClose}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="event-name" className="block text-ash text-sm font-medium mb-1">
            Name
          </label>
          <input
            id="event-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Event name"
            className="w-full px-4 py-3 rounded-xl bg-shadow border border-charcoal text-ash placeholder-silver focus:outline-none focus:ring-2 focus:ring-ether/50"
            maxLength={255}
            autoFocus
          />
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-3 rounded-xl border border-shadow text-ash font-medium hover:bg-shadow"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={saving || !name.trim()}
            className="flex-1 py-3 rounded-xl bg-ether text-void font-medium disabled:opacity-50"
          >
            {saving ? 'Creating...' : 'Create'}
          </button>
        </div>
      </form>
    </ModalShell>
  );
}

export default CreateEventModal;
